<main class="sso-error" *ngIf="translationsLoaded">
  <h1 class="header">{{ messageKey | t }}</h1>
  <p class="subheader">{{ subMessageKey | t }}</p>
  <sn-flat-button color="accent" routerLink="/auth/sign-in">{{ 'auth.sso.error.returnToSignIn' | t }}</sn-flat-button>
</main>
